module.exports = __webpack_public_path__ + "img/speakers-background.fbe26e80.gif";